import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class TetrisPage extends Component {
	componentDidMount() {
		// Mount the Tetris game when component mounts
		if (window.TetrisGame && window.TetrisGame.mount) {
			this.unmount = window.TetrisGame.mount('tetris-container');
		}
	}

	componentWillUnmount() {
		// Cleanup when leaving the page
		if (this.unmount) {
			this.unmount();
		}
	}

	render() {
		return (
			<div className="tetris-page" style={{ minHeight: '100vh', paddingTop: '80px', backgroundColor: '#1a1a2e' }}>
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<Link to="/" className="btn btn-primary" style={{ marginBottom: '20px' }}>
								<i className="fa fa-arrow-left"></i> Back to Portfolio
							</Link>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12 text-center">
							<h2 style={{ color: 'white', marginBottom: '30px' }}>Tetris</h2>
							<div id="tetris-container" style={{ display: 'inline-block' }}></div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TetrisPage.jsx